import { InputOTPForm } from '@/components/auth/otp-form';
import Logo from '@/components/logo';
import { Button } from '@/components/ui/button';
import { generateTOTP, getMe, isAuthenticated } from '@/lib/api';
import { UserData } from '@/types/index';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { useEffect, useState } from 'react';
import { isDevMode } from '@/lib/utils';

export const Route = createFileRoute('/waiting')({
  beforeLoad: async ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
    if (isDevMode()) {
      throw redirect({ to: '/' });
    }
  },
  component: Waiting,
});

function Waiting() {
  const [userData, setUserData] = useState<UserData | null>(null);

  useEffect(() => {
    const fetchMe = async () => {
      const me = await getMe();
      setUserData(me);
    };
    if (isDevMode()) {
      window.location.href = '/';
      return;
    }
    fetchMe();
  }, []);

  if (!userData) {
    return <div>Loading...</div>;
  }

  if (userData.state === 'waitingForTOTP') {
    return (
      <div className="w-full min-h-screen p-6 py-10 md:p-20 text-white bg-gradient-to-r from-heineken-green via-heineken-light-green to-heineken-dark-green">
        <div className="max-w-3xl mx-auto flex flex-col items-center">
          <Logo className="mb-10" />
          <div className="w-full flex flex-col items-center space-y-4 p-6 bg-white rounded-lg shadow-md text-heineken-text">
            <Lock className="w-10 h-10 text-heineken-text" />
            <h1 className="font-heineken font-bold text-4xl md:text-5xl text-center text-heineken-green">
              Egyszeri kód beküldése
            </h1>
            <p className="text-sm">
              Kérlek add meg a kódot amit emailben kaptál.
            </p>
            <InputOTPForm isEmail={true} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full min-h-screen p-6 py-10 md:p-20 text-white bg-gradient-to-r from-heineken-green via-heineken-light-green to-heineken-dark-green">
      <div className="max-w-3xl mx-auto flex flex-col items-center">
        <Logo className="mb-10" />
        <div className="w-full flex flex-col items-center space-y-4 p-6 bg-white rounded-lg shadow-md text-heineken-text">
          <Lock className="w-10 h-10 text-heineken-text" />
          <h1 className="font-heineken font-bold text-4xl md:text-5xl text-center text-heineken-green">
            Két lépéses hitelesítés engedélyezése
          </h1>
          <p className="text-sm">
            Két lépéses hitelesítés engedélyezése a fiókodhoz emailen keresztül.
          </p>
          <Button
            type="button"
            variant="secondary"
            onClick={async () => {
              const result = await generateTOTP({ isEmail: true });
              if (result) {
                setUserData((prev) =>
                  prev ? { ...prev, state: 'waitingForTOTP' } : null
                );
              }
            }}
          >
            Emailes 2FA engedélyezése
          </Button>
        </div>
      </div>
    </div>
  );
}
